import { render, staticRenderFns } from "./Close.vue?vue&type=template&id=5fb3b314&"
import script from "./Close.vue?vue&type=script&lang=js&"
export * from "./Close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports